exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-element[data-v-47fae69a]{max-width:250px;cursor:zoom-in}", ""]);

// exports
